/*
 *  Ball Display Class
 *  Karol Brennan
 *  5.13.2018
 *  This class is used to display the current ball.
 */
import React from "react";
import _ from "underscore";
import logo from "../logo.svg";

class BallDisplay extends React.Component {
	render() {
		let currentBall = _.where(this.props.balls, { active: true })[0];
		if (currentBall) {
			let color = "white";
			switch (currentBall.letter) {
				case "B":
					color = "blue";
					break;
				case "I":
					color = "red";
					break;
				case "N":
					color = "white";
					break;
				case "G":
					color = "green";
					break;
				case "O":
					color = "yellow";
					break;
				default:
					break;
			}
				return (
					<div className="lpb-ball-display">
						<div className="lpb-ball-display-stage">
							<div id="ball" className={color + " relative notranslate"}>
								<div className="content">
									<span>
									<span className="ball-letter">{currentBall.letter}</span>
									<span className="ball-number">{currentBall.number}</span>
								</span>
							</div>
						</div>
					</div>
				</div>
			);
		} else {
				return (
					<div className="lpb-ball-display">
						<div className="lpb-ball-display-stage">
							<div id="ball" className="white relative notranslate">
								<div className="content">
									<span>
									<img src={logo} alt="Lets Play Bingo Logo" />
								</span>
							</div>
						</div>
					</div>
				</div>
			);
		}
	}
}

export default BallDisplay;
